import * as React from "react";

const FullScreenCardPage: React.FC<
  React.PropsWithChildren<{
    className?: string;
  }>
> = ({ className, children }) => {
  return (
    <div
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "dt_content_primary",
        padding: "dt_xxl",
        alignItems: "stretch",
        justifyContent: "stretch",
        display: "flex",
      }}
      className={className}
    >
      <div
        sx={{
          backgroundColor: "dt_background_primary",
          borderRadius: "dt_radius_s",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          flexGrow: 1,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default FullScreenCardPage;
